var portalContainer = 'portalContainer_portalContainer__1a7h8q0';

export { portalContainer };
//# sourceMappingURL=portalContainer.vanilla.mjs.map
